module.exports = __webpack_public_path__ + "img/jobIcon.d9614a28.png";